import { typedQueryClient, useTypedMutation } from "hooks";
import { WarrantyQueryKeys } from "modules/WarrantyDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DeletePinPayload } from "modules/AppointmentDetails/components/Interventions/hooks";

export const useDeletePinMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: DeletePinPayload) => {
      await ApiInstance.post("/pins/delete", payload);
    },
    onSuccess: payload => {
      const paginatedPins = typedQueryClient.getQueryData(WarrantyQueryKeys.listWarranties);
      if (!paginatedPins?.items?.length) return;

      typedQueryClient.setQueryData(WarrantyQueryKeys.listWarranties, {
        ...paginatedPins,
        items: paginatedPins.items.filter(p => p.question_result_id !== payload.question_result_id || p.intervention_id !== payload.intervention_id)
      });
    }
  });
